import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { Alert, ConfirmButton } from 'components/common';

const UsersSetLocked = connect((state) => state)(
  class extends Component {
    updateLocked = async () => {
      const { handleSuccess, targetUser } = this.props;
      const data = { locked: !targetUser.locked };
      const response = await api.put(`/admin/users/${targetUser.id}`, data);
      if (!response.data || !response.data.success) return false;
      await handleSuccess();
      return true;
    };

    render() {
      const { messages, targetUser, user } = this.props;

      let actionText = messages.usersLockAccount;
      let buttonText = messages.usersLockAccount;
      let confirmText = (
        <>
          {targetUser.hasOtherCourses ? (
            <Alert
              style={{ marginBottom: 15 }}
              text={messages.usersDeleteUserConfirmWarning}
              type="warning-light"
            />
          ) : null}
          <div>{messages.usersLockAccountConfirm}</div>
        </>
      );
      let confirmTitle = messages.usersLockAccount;
      let successMessage = messages.usersLockAccountSuccess;
      let buttonIcon = 'lock';
      let category = 'danger';

      if (targetUser.locked) {
        actionText = messages.usersUnlockAccount;
        buttonText = messages.usersUnlockAccount;
        confirmText = messages.usersUnlockAccountConfirm;
        confirmTitle = messages.usersUnlockAccount;
        successMessage = messages.usersUnlockAccountSuccess;
        buttonIcon = 'unlock';
        category = 'success';
      }

      return (
        <ConfirmButton
          actionText={actionText}
          buttonIcon={buttonIcon}
          buttonIsDropdown={true}
          buttonText={buttonText}
          category={category}
          confirmText={confirmText}
          confirmTitle={confirmTitle}
          disabled={
            user &&
            targetUser &&
            !user.roles.includes('superadmin') &&
            targetUser.roles.includes('admin')
          }
          onConfirm={this.updateLocked}
          stopPropagation={true}
          successMessage={successMessage}
        />
      );
    }
  }
);

export default UsersSetLocked;
